import { ButtonPrimary, ButtonWithIcon } from '@ui/button';
import { IconArrowDown, IconArrowUp } from '@ui/icons';
import { Link } from '@lib/routing-engine';
import { useStore } from '@lib/state-engine';
import { OutsideClick } from '@lib/outside-click';
import { $dropdownOpened, toggleOpenDropdown } from './model';
import styles from './styles.module.css';

export const StorageCreateWarehouse = () => {
  const opened = useStore($dropdownOpened);

  return (
    <div className={styles.container}>
      <ButtonPrimary
        className={styles.button}
        label="Добавить склад"
        iconRight={opened ? IconArrowUp : IconArrowDown}
        onClick={() => toggleOpenDropdown(!opened)}
        data-opened={opened}
      />
      {opened && (
        <OutsideClick onClickOutside={() => toggleOpenDropdown(false)}>
          <ul>
            <li>
              <Link
                to="/storage/create-warehouse"
                className={styles.link}
                onClick={() => toggleOpenDropdown(false)}
              >
                <ButtonWithIcon icon="WarehouseSleeveList" />
                &nbsp;рукавный
              </Link>
            </li>
            <li>
              <Link
                to="/storage/create-warehouse/fixed"
                className={styles.link}
                onClick={() => toggleOpenDropdown(false)}
              >
                <ButtonWithIcon icon="WarehouseStationaryList" />
                &nbsp;стационарный
              </Link>
            </li>
          </ul>
        </OutsideClick>
      )}
    </div>
  );
};
